/**
 * The business-register section: four routes and nothing else.
 *
 * This file used to be the whole section - 657 lines holding the list, a
 * ten-column table, the filter panel and the sync status, which is well past the
 * point where anybody can find the piece they came for (AGENTS.md §4).
 * Everything now lives in a file named after what it does; the entry point kept
 * its name so no caller had to move (`CrmLayout` looks the section up by this
 * import).
 *
 * - `AriregisterList`     the register as a list you can work
 * - `ListHead`            its page head: the size of the mirror and how fresh it is
 * - `AriregisterFilters`  the search and filter panel over it
 * - `map/MapView`         the same register as a map of the country
 * - `data/`               what refreshes the mirror and what ranks it
 * - `EntityRowMenu`       the actions at the end of a row
 * - `status.ts`           register status as the design's tones
 *
 * ⚠ `kaart` has to be declared BEFORE `:regCode`. The dynamic segment matches
 * any single word, so a route order that put it first would send /kaart to the
 * company detail page looking for a company whose registry code is "kaart".
 */
import { Route, Routes } from "react-router-dom";
import type { StaffUser } from "../../../lib/auth";
import { AriregisterDetail } from "./AriregisterDetail";
import { AriregisterList } from "./AriregisterList";
import { PersonDetail } from "./PersonDetail";
import { PersonSearch } from "./PersonSearch";
import { MapView } from "./map/MapView";

export function AriregisterSection({ user }: { user: StaffUser }) {
  return (
    <Routes>
      <Route index element={<AriregisterList user={user} />} />
      <Route path="kaart" element={<MapView user={user} />} />
      <Route path="isikud" element={<PersonSearch />} />
      <Route path="isik/:hash" element={<PersonDetail />} />
      <Route path=":regCode" element={<AriregisterDetail user={user} />} />
    </Routes>
  );
}
